import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import {
  Col,
  Container,
  Row,
  Nav,
  NavItem,
  TabPane,
  TabContent,
  Button,
  Badge,
} from 'reactstrap';

import LoadingSpinner from '../../shared/components/LoadingSpinner';

import {
  createErrorMessage,
  // createWarningMessage,
} from '../../helpers/notification';
import {
  fetchMySubject,
} from '../../redux/actions/studentSubjectsActions';
import Homework from './Tasks';
import HorariosTable from '../Profesor/PlaneamientoForm/components/HorariosTable';
import Assistance from './Assistance/index';

class StudentDataContainer extends PureComponent {
  static propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    history: PropTypes.shape({}).isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      activeTab: '1',
      materiaPeriodo: null,
      loadAssistance: false,
    };

    this.inputStyle = {
      fontSize: '18px',
      height: '36px',
      color: 'greenyellow',
      textAlign: 'center',
      fontWeight: 'bold',
      backgroundColor: '#232329',
    };
  }

  componentDidMount() {
    this.getMateriaPeriodo();
  }

  getMateriaPeriodo = () => {
    const { id } = this.props;
    this.setState({ loading: true });
    fetchMySubject({
      id,
      onSuccess: (materiaPeriodo) => {
        this.setState({
          materiaPeriodo, loading: false,
        });
      },
      onError: () => {
        this.setState({
          materiaPeriodo: {}, loading: false,
        });
        createErrorMessage('Error al intentar cargar los datos de la materia');
      },
    });
  }

  toggle = (tab) => {
    const { activeTab } = this.state;
    if (activeTab !== tab) {
      if (tab === '2') {
        this.setState({
          activeTab: tab,
          loadAssistance: true,
        });

        return;
      }

      this.setState({
        activeTab: tab,
        loadAssistance: false,
      });
    }
  };

  goBack = () => {
    const { history } = this.props;
    history.goBack();
  }

  format = value => (
    <Badge
      key={`item_${value}`}
      style={{ fontSize: '0.9rem' }}
      color={!Number.isInteger(value) ? 'secondary' : 'primary'}
    >
      {value}{!Number.isInteger(value) ? '' : '%'}
    </Badge>
  );

  render() {
    const {
      materiaPeriodo,
      loading,
      activeTab,
      loadAssistance,
    } = this.state;

    if (loading || !materiaPeriodo) {
      return (
        <LoadingSpinner />
      );
    }

    return (
      <Container>
        <Row>
          <Col md={12} style={{ paddingRight: '7px', paddingLeft: '7px' }}>
            <h2 className="page-title text-center">
              <span>{materiaPeriodo.materia}</span>
              <h4>{materiaPeriodo.seccion}</h4>
            </h2>

            <div className="form" style={{ marginTop: '0.5rem' }}>
              <Col sm={6} md={3} lx={12}>
                <div className="card__title" style={{ display: 'flex', columnGap: '0.5rem' }}>
                  <h5 className="bold-text">Carrera:{' '}</h5>
                  <h5 className="bold-text">{materiaPeriodo.carrera}</h5>
                </div>
              </Col>
              <Col sm={6} md={3} lx={12}>
                <div className="card__title" style={{ display: 'flex', columnGap: '0.5rem' }}>
                  <h5 className="bold-text">Semestre:{' '}</h5>
                  <h5 className="bold-text">{materiaPeriodo.semestre}</h5>
                </div>
              </Col>
              <Col sm={6} md={3} lx={12}>
                <div className="card__title" style={{ display: 'flex', columnGap: '0.5rem' }}>
                  <h5 className="bold-text">Año:{' '}</h5>
                  <h5 className="bold-text">{materiaPeriodo.anho}</h5>
                </div>
              </Col>
              <Col sm={6} md={3} lx={12}>
                <div className="card__title" style={{ display: 'flex', columnGap: '0.5rem' }}>
                  <h5 className="bold-text">Horas Semanales</h5>
                </div>
              </Col>
              <Col lg={12} md={12} lx={12}>

                <div className="table-wrapper" style={{ marginBottom: '20px' }}>
                  <HorariosTable
                    key="horariosTable"
                    name="horariosTable"
                    esAlumno="true"
                    codigoClassroom={materiaPeriodo.codigoClassroom}
                    materiaPeriodo={{
                      ...materiaPeriodo,
                    }}
                    profesores={materiaPeriodo.profesores}
                    items={materiaPeriodo.horarios}
                  />
                </div>

              </Col>
            </div>

          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Container style={{ marginBottom: '1rem' }}>
              <Row style={{ gap: '0.5rem' }}>
                <Col lg={2} md={3} sm={6} xs={12}>
                  <h5 className="bold-text">
                    {this.format('PP:')}{' '}
                    {this.format(Math.round(materiaPeriodo.porcentajePP))}
                  </h5>
                </Col>
                <Col lg={3} md={5} sm={6} xs={12}>
                  <h5 className="bold-text">
                    {this.format('Asistencias:')}{' '}
                    {this.format(Math.round(materiaPeriodo.porcentajeAsistencia))}
                  </h5>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Nav tabs>
              <NavItem className="pr-1" style={{ marginRight: '0.3rem' }}>
                {activeTab === '1'
                  ? (
                    <Button active color="secondary" className="mb-0" style={{ marginBottom: '1rem' }}>
                      Tareas
                    </Button>
                  )
                  : (
                    <Button
                      outline
                      color="secondary"
                      className="mb-0"
                      style={{ marginBottom: '1rem' }}
                      onClick={() => this.toggle('1')}
                    >
                      Tareas
                    </Button>
                  )
                }
              </NavItem>
              <NavItem className="pr-1" style={{ marginRight: '0.3rem' }}>
                {activeTab === '2'
                  ? (
                    <Button active color="secondary" className="mb-0" style={{ marginBottom: '1rem' }}>
                      Asistencias
                    </Button>
                  )
                  : (
                    <Button
                      outline
                      color="secondary"
                      className="mb-0"
                      style={{ marginBottom: '1rem' }}
                      onClick={() => this.toggle('2')}
                    >
                      Asistencias
                    </Button>
                  )
                }
              </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                <Row>
                  <Homework
                    {...materiaPeriodo}
                    materiaPeriodoId={materiaPeriodo.id}
                  />
                </Row>
              </TabPane>
              <TabPane tabId="2">
                <Row>
                  <Assistance loadAssistance={loadAssistance} subjectPeriodId={materiaPeriodo.id} />
                </Row>
              </TabPane>
            </TabContent>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <div className="card__actions">
              <button
                type="submit"
                className="btn btn-outline-secondary"
                onClick={this.goBack.bind(this)}
              >Volver
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default withRouter(StudentDataContainer);
